import axios from "axios";
import { logError } from "utils/logger";

export type EarliestBookingSlots = {
    Allocated: AllocatedAvailability;
    Nearest: NearestAvailability[];
};

export type AllocatedAvailability = {
    FirstSlot: string;
    Price: number;
};

export type NearestAvailability = {
    SiteId: number;
    SiteName: string;
    FirstSlot: string;
    Price: number;
};

export type GetEarliestBookingSlotRequest = {
    AllocatedSiteName: string;
    AllocatedSiteId: number;
    CurrentSiteName: string;
    CurrentSiteId: number;
    IntendedSiteName: string;
    IntendedSiteId: number;
    IsCommercialVehicle: boolean;
    IsInTransit: boolean;
    HasDisabledV5: boolean;
    Postcode: string;
    VehicleId: number;
};

export const getEarliestBookingSlots = async (params: GetEarliestBookingSlotRequest) => {
    try {
        const response = await axios.post<EarliestBookingSlots>(
            process.env.NEXT_PUBLIC_GET_EARLIEST_BOOKING_SLOTS_ENDPOINT,
            params,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    } catch (err: any) {
        logError(err.message, err);
    }
};

export default getEarliestBookingSlots;
